// extracted by mini-css-extract-plugin
export default {"products":"products_products__dkzqA","products__banner":"products_products__banner__1CG+y","products__wrapper":"products_products__wrapper__PY3wS"};